const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const DEVELOPMENT_DEFAULTS = Object.freeze({
  REACT_APP_BRAND_LABEL: 'Landlix',
  REACT_APP_INSTAGRAM_URL: 'https://www.instagram.com/example',
  REACT_APP_PORTFOLIO_BASE_URL: 'http://localhost:8080',
  REACT_APP_PUBLIC_SITE_URL: 'http://localhost:3000',
  REACT_APP_SUPPORT_EMAIL: 'support@example.com',
});

function requiredValue(environment, name, isProduction) {
  const value = String(environment[name] || '').trim();
  if (value) {
    return value;
  }

  if (isProduction) {
    throw new Error(`${name} is required in production`);
  }

  return DEVELOPMENT_DEFAULTS[name];
}

function validatedUrl(environment, name, isProduction) {
  const value = requiredValue(environment, name, isProduction);
  let url;

  try {
    url = new URL(value);
  } catch (error) {
    throw new Error(`${name} must be an absolute HTTP(S) URL`);
  }

  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) {
    throw new Error(`${name} must be an absolute HTTP(S) URL without credentials`);
  }
  if (url.search || url.hash) {
    throw new Error(`${name} must not contain a query string or fragment`);
  }

  return value.replace(/\/+$/, '');
}

function publicConfigurationFromEnvironment(environment = process.env) {
  const isProduction = environment.NODE_ENV === 'production';
  const publicSiteUrl = validatedUrl(environment, 'REACT_APP_PUBLIC_SITE_URL', isProduction);
  const supportEmail = requiredValue(environment, 'REACT_APP_SUPPORT_EMAIL', isProduction);

  if (!EMAIL_PATTERN.test(supportEmail)) {
    throw new Error('REACT_APP_SUPPORT_EMAIL must be a valid email address');
  }

  return Object.freeze({
    brandLabel: requiredValue(environment, 'REACT_APP_BRAND_LABEL', isProduction),
    instagramUrl: validatedUrl(environment, 'REACT_APP_INSTAGRAM_URL', isProduction),
    portfolioBaseUrl: validatedUrl(environment, 'REACT_APP_PORTFOLIO_BASE_URL', isProduction),
    publicSiteHost: new URL(publicSiteUrl).host,
    publicSiteUrl,
    supportEmail,
  });
}

const publicConfiguration = publicConfigurationFromEnvironment();

module.exports = {
  publicConfiguration,
  publicConfigurationFromEnvironment,
};
